import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";

const SponsorsPage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Typography variant="h2" gutterBottom>
                        Спонсоры
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Спонсоров я пока не нашёл.
                    </Typography>

                    <Typography variant="body1" >
                        Если есть желание проспонсировать хаккатон - пишите мне в личку, обсудим условия сотрудничества:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <a href="https://t.me/Alexander_Berdyshev" target="_blank" rel="noopener noreferrer">t.me/Alexander_Berdyshev</a>
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default SponsorsPage;